var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "p-absolute top-0 right-0 bottom-0 left-0 bg-black-0-2",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "p-absolute m-auto top-0 right-0 bottom-0 left-0 p-t-25 r-2 bg-white shadow-5-g-400 z-index-3",
          staticStyle: { width: "70%", height: "90%", "border-radius": "5px" },
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                "padding-top": "10px",
                "padding-left": "10px",
                width: "100%",
                "text-align": "left",
                "padding-bottom": "17px",
                color: "#999999",
                "border-bottom": "1px solid #E8E8E9",
                "font-size": "14px",
              },
            },
            [_vm._v("聊天记录")]
          ),
          _c("i", {
            staticClass:
              "el-icon-close y-fs-18 y-c-p y-fc-999 p-absolute top-5 right-10",
            on: { click: _vm.close },
          }),
          _c(
            "div",
            {
              staticClass: "p-relative f-left h-100-p bg-white b-r b-c-150",
              staticStyle: {
                width: "100%",
                "margin-top": "20px",
                "border-radius": "5px",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "o-auto p-b-20 left-personnel-box historyScrollContainer",
                  staticStyle: { height: "92%" },
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "historyScroll",
                      staticStyle: { "padding-top": "0.1px" },
                    },
                    _vm._l(_vm.forData, function (item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          staticClass: "p-y-10 flex cursor-pointer",
                          staticStyle: {
                            "margin-top": "10px",
                            background: "#fff",
                            width: "98%",
                            "margin-left": "10px",
                            "border-bottom": "1px solid #E8E8E9",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-table-cell v-a-middle h-100-p w-64",
                              staticStyle: { "text-align": "center" },
                            },
                            [
                              item.from.length == 32
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "c-white rounded bg-violet",
                                      staticStyle: {
                                        width: "40px",
                                        height: "40px",
                                        border: "1px solid #f2f3f4",
                                        "line-height": "40px",
                                        display: "inline-block",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getShortNickname(
                                            item.fromNick || ""
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              item.from.length != 32 && item.fromNick != "小圆"
                                ? _c("img", {
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                    },
                                    attrs: {
                                      src: require("@/assets/images/im/kefu.svg"),
                                    },
                                  })
                                : _vm._e(),
                              item.from.length != 32 && item.fromNick == "小圆"
                                ? _c("img", {
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                    },
                                    attrs: {
                                      src: require("@/assets/images/im/xiaoyuan.png"),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "content",
                              staticStyle: { width: "91%" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "flex header",
                                  staticStyle: { color: "#999" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-80 w-s-nowrap t-o-ellipsis o-hidden",
                                    },
                                    [_vm._v(_vm._s(item.fromNick))]
                                  ),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.timeHandler(item.time, true))
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "m-r-4 m-t-10",
                                  staticStyle: {
                                    width: "94%",
                                    "word-break": "break-all",
                                  },
                                },
                                [
                                  item.type == 0 || item.type == "text"
                                    ? _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.iconhandler(item.body)
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                  item.type == 1 || item.type == "image"
                                    ? _c("el-image", {
                                        staticStyle: {
                                          "max-width": "150px",
                                          height: "auto",
                                        },
                                        attrs: {
                                          src: JSON.parse(
                                            item.attach
                                          ).url.replace(/:10080/, ""),
                                          "preview-src-list": [
                                            JSON.parse(item.attach).url.replace(
                                              /:10080/,
                                              ""
                                            ),
                                          ],
                                        },
                                      })
                                    : _vm._e(),
                                  (item.type == 6 || item.type == "file") &&
                                  !(
                                    (item.type == 6 || item.type == "file") &&
                                    (JSON.parse(
                                      item.attach
                                    ).ext.toLowerCase() == "mp4" ||
                                      JSON.parse(
                                        item.attach
                                      ).ext.toLowerCase() == "ogv" ||
                                      JSON.parse(
                                        item.attach
                                      ).ext.toLowerCase() == "webm" ||
                                      JSON.parse(
                                        item.attach
                                      ).ext.toLowerCase() == "ogg" ||
                                      JSON.parse(
                                        item.attach
                                      ).ext.toLowerCase() == "mov" ||
                                      JSON.parse(
                                        item.attach
                                      ).ext.toLowerCase() == "mkv" ||
                                      JSON.parse(
                                        item.attach
                                      ).ext.toLowerCase() == "mpeg" ||
                                      JSON.parse(
                                        item.attach
                                      ).ext.toLowerCase() == "mp3" ||
                                      JSON.parse(
                                        item.attach
                                      ).ext.toLowerCase() == "wav")
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "cursor-pointer",
                                          staticStyle: {
                                            "max-width": "360px",
                                            display: "flex",
                                            "align-items": "center",
                                            cursor: "pointer",
                                            position: "relative",
                                            padding: "15px 0",
                                          },
                                          on: {
                                            mouseover: function ($event) {
                                              return _vm.donwloadfilePicShow(
                                                item
                                              )
                                            },
                                            mouseout: function ($event) {
                                              return _vm.donwloadfilePicHide(
                                                item
                                              )
                                            },
                                            click: function ($event) {
                                              return _vm.downloadFile(item)
                                            },
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "28px",
                                              height: "36px",
                                            },
                                            attrs: {
                                              src: require("@/assets/images/im/filelog.png"),
                                            },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "max-width": "280px",
                                                color: "#653EB3",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "t-d-underline",
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                    "text-overflow": "ellipsis",
                                                    "white-space": "nowrap",
                                                    "max-width": "280px",
                                                    "padding-left": "10px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        JSON.parse(item.attach)
                                                          .name
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    overflow: "hidden",
                                                    "text-overflow": "ellipsis",
                                                    "white-space": "nowrap",
                                                    "max-width": "280px",
                                                    "padding-left": "10px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.changeByte(
                                                          JSON.parse(
                                                            item.attach
                                                          ).size
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    item.donwloadfilePicShowFlag,
                                                  expression:
                                                    "item.donwloadfilePicShowFlag",
                                                },
                                              ],
                                              staticStyle: {
                                                position: "absolute",
                                                width: "100%",
                                                height: "80%",
                                                left: "0px",
                                                "border-radius": "6px",
                                                background:
                                                  "rgb(51, 51, 51,0.2)",
                                              },
                                            },
                                            [_vm._m(0, true)]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              (item.type === "custom" || item.type === 100) &&
                              item.attach &&
                              JSON.parse(item.attach).type == 15
                                ? _c(
                                    "div",
                                    { staticClass: "c-g-250 cursor-pointer" },
                                    [
                                      JSON.parse(item.attach).data &&
                                      JSON.parse(item.attach).data.md5
                                        ? _c("div", [
                                            _c("div", [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    color: "#666",
                                                    "border-bottom":
                                                      "1px solid",
                                                    "margin-bottom": "5px",
                                                    "padding-bottom": "5px",
                                                  },
                                                },
                                                [_vm._v("聊天记录")]
                                              ),
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    color: "#999",
                                                    "max-width": "100%",
                                                    height: "20px",
                                                    "text-overflow": "ellipsis",
                                                    overflow: "hidden",
                                                    "white-space": "nowrap",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "color: #333;margin-right: 7px;",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          JSON.parse(
                                                            item.attach
                                                          ).data
                                                            .messageAbstract[0]
                                                            .sender
                                                        ) + ":"
                                                      ),
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        JSON.parse(item.attach)
                                                          .data
                                                          .messageAbstract[0]
                                                          .message
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              JSON.parse(item.attach).data
                                                .messageAbstract.length > 1
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        color: "#999",
                                                        "max-width": "100%",
                                                        height: "20px",
                                                        "text-overflow":
                                                          "ellipsis",
                                                        overflow: "hidden",
                                                        "white-space": "nowrap",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "color: #333;margin-right: 7px;",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              JSON.parse(
                                                                item.attach
                                                              ).data
                                                                .messageAbstract[1]
                                                                .sender
                                                            ) + ":"
                                                          ),
                                                        ]
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            JSON.parse(
                                                              item.attach
                                                            ).data
                                                              .messageAbstract[1]
                                                              .message
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                          ])
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                              item.type == 3 ||
                              item.type == "video" ||
                              ((item.type == 6 || item.type == "file") &&
                                (JSON.parse(item.attach).ext.toLowerCase() ==
                                  "mp4" ||
                                  JSON.parse(item.attach).ext.toLowerCase() ==
                                    "ogv" ||
                                  JSON.parse(item.attach).ext.toLowerCase() ==
                                    "webm" ||
                                  JSON.parse(item.attach).ext.toLowerCase() ==
                                    "ogg" ||
                                  JSON.parse(item.attach).ext.toLowerCase() ==
                                    "mov" ||
                                  JSON.parse(item.attach).ext.toLowerCase() ==
                                    "mkv"))
                                ? _c(
                                    "video",
                                    {
                                      staticClass: "cursor-pointer",
                                      staticStyle: {
                                        width: "200px",
                                        height: "200px",
                                      },
                                      attrs: { controls: "true" },
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          type: "video/mp4",
                                          src: JSON.parse(
                                            item.attach
                                          ).url.replace(/:10080/, ""),
                                        },
                                      }),
                                      _c("source", {
                                        attrs: {
                                          type: "video/ogg",
                                          src: JSON.parse(
                                            item.attach
                                          ).url.replace(/:10080/, ""),
                                        },
                                      }),
                                      _c("source", {
                                        attrs: {
                                          type: "video/webm",
                                          src: JSON.parse(
                                            item.attach
                                          ).url.replace(/:10080/, ""),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              item.type == 2 ||
                              item.type == "audio" ||
                              ((item.type == 6 || item.type == "file") &&
                                (JSON.parse(item.attach).ext.toLowerCase() ==
                                  "mpeg" ||
                                  JSON.parse(item.attach).ext.toLowerCase() ==
                                    "mp3" ||
                                  JSON.parse(item.attach).ext.toLowerCase() ==
                                    "wav" ||
                                  JSON.parse(item.attach).ext.toLowerCase() ==
                                    "ogg"))
                                ? _c(
                                    "audio",
                                    {
                                      staticClass: "cursor-pointer",
                                      staticStyle: {
                                        padding: "3px",
                                        "background-color": "#fff",
                                      },
                                      attrs: { controls: "true" },
                                    },
                                    [
                                      _c("source", {
                                        attrs: {
                                          type: "video/mpeg",
                                          src: JSON.parse(
                                            item.attach
                                          ).url.replace(/:10080/, ""),
                                        },
                                      }),
                                      _c("source", {
                                        attrs: {
                                          type: "video/wav",
                                          src: JSON.parse(
                                            item.attach
                                          ).url.replace(/:10080/, ""),
                                        },
                                      }),
                                      _c("source", {
                                        attrs: {
                                          type: "video/ogg",
                                          src: JSON.parse(
                                            item.attach
                                          ).url.replace(/:10080/, ""),
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
          height: "100%",
        },
      },
      [
        _c("img", {
          staticClass: "information",
          staticStyle: { width: "30px", height: "30px" },
          attrs: { src: require("@/assets/images/im/downloadFile.png") },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }